import React, { useContext, useEffect, useRef, useState } from 'react';
import { mergeClasses, cn } from '#lib/helpers/class.js';
import { isUndefined } from '#lib/utils/undefined.js';
import { UserContext } from '#src/index.jsx';
import { isFunction } from '#lib/utils/function.js';
import Button from '#lib/components/button.jsx';
import { SparklesIcon } from '@heroicons/react/24/outline';

export function CustomTextArea(prop) {
    const { value, name, label, placeholder, form, className, hasError, crud, clearError, onClick, busy, isSuccess } =
        prop;
    const { getLanguage } = useContext(UserContext);
    const [isEditing, setIsEditMode] = useState(false);
    const defaultValue = useRef(value);
    const ref = useRef(null);
    useEffect(() => {
        // Al primo render value sarà undefined, quindi non faccio nulla
        // Se value non è undefined e defaultValue è undefined, allora setto defaultValue a value
        if (!isUndefined(value) && isUndefined(defaultValue.current)) {
            defaultValue.current = value;
        }
    }, [value]);

    useEffect(() => {
        if (!isUndefined(crud.data[name])) defaultValue.current = crud.data[name];
    }, [crud.dataUpdatedAt]);

    useEffect(() => {
        if (!isUndefined(value)) defaultValue.current = value;
    }, [isSuccess]);

    useEffect(() => {
        if (isEditing) {
            ref.current.focus();
        }
    }, [isEditing]);

    // Press Ctrl + Enter exit edit mode
    useEffect(() => {
        const pressFunction = (event) => {
            if (event.ctrlKey && event.key === 'Enter') {
                setIsEditMode(false);
            }
        };
        document.addEventListener('keydown', pressFunction);
        return () => document.removeEventListener('keydown', pressFunction);
    }, []);

    const handleInput = (e) => {
        const value = e.target.innerText;
        if (value && hasError && isFunction(clearError)) clearError(name);

        form.handleChange(name, value);
    };

    return (
        <div className="relative">
            <label htmlFor={name} className="text-xs text-neutral-700 flex justify-between items-center mt-1">
                {label}
                {name === 'description' && (
                    <Button
                        className={
                            'px-2 flex items-center cursor-pointer h-[20px] bg-sky-500 hover:bg-sky-600 text-white rounded-md shadow-sm shadow-sky-900/50'
                        }
                        onClick={onClick}
                        busy={busy}
                    >
                        <span className="mr-2">{_t.edit.planner.aiButton()}</span>
                        <SparklesIcon width=".9rem" height=".9rem" />
                    </Button>
                )}
            </label>
            <div
                contentEditable={isEditing}
                // create this logic to remove red underline when user doesn't use the div to write anything
                onClick={() => {
                    setIsEditMode(true);
                }}
                onBlur={() => setIsEditMode(false)}
                ref={ref}
                className={mergeClasses(
                    cn(
                        'bg-transparent z-50 w-full border-b border-gray-300 hover:border-gray-400 focus:outline-none focus:border-gray-500 text-justify hyphens-auto hover:cursor-text min-h-6 max-h-60 overflow-y-auto',
                        !value && 'text-gray-400',
                        hasError && 'border-red-500 hover:border-red-500 focus:border-red-500'
                    ),
                    className
                )}
                lang={getLanguage() ?? 'en'}
                dangerouslySetInnerHTML={{ __html: defaultValue.current }}
                onInput={handleInput}
            />
            {!value && (
                <div className={mergeClasses('absolute -z-50 left-0 bottom-0 h-6 text-gray-400 event-none', className)}>
                    {placeholder}
                </div>
            )}
        </div>
    );
}
